var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1458,
    height: 215,
    viewBox: "0 0 1458 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_79",
    x: 0,
    y: 0,
    width: 1458,
    height: 215,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(9 -2107.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 2107.5)",
    filter: "url(#Rectangle_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79-2",
    "data-name": "Rectangle 79",
    width: 1440,
    height: 197,
    transform: "translate(9 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    transform: "translate(1279 2151.5)",
    fill: "none",
    stroke: "#006bd9",
    strokeWidth: 5,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 78.5,
    r: 78.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 78.5,
    r: 76,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    transform: "translate(19 2141.5)",
    fill: "none",
    stroke: "#006bd9",
    strokeWidth: 39,
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 78.5,
    r: 78.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 78.5,
    r: 59,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "translate(430 2244.5)",
    fill: "none",
    stroke: "#006bd9",
    strokeWidth: 10,
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(1043 2168.5)",
    fill: "none",
    stroke: "#006bd9",
    strokeWidth: 5,
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 28,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/Footer.60788b2b9b9ed1709cafedba7ba388b6.svg";
export { ForwardRef as ReactComponent };